"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FlagshipSmartphoneShowcase() {
  const tickerItems = [{
    id: 1,
    text: "IPHONE 15 PRO [TW-01]"
  }, {
    id: 2,
    text: "SAMSUNG S24 ULTRA [TW-02]"
  }, {
    id: 3,
    text: "PIXEL 8 PRO [TW-03]"
  }, {
    id: 4,
    text: "ONEPLUS 12 [TW-04]"
  }, {
    id: 5,
    text: "XIAOMI 14 ULTRA [TW-05]"
  }];
  return <section data-section-id="2078" id="flagship-smartphone-showcase" className="bg-background text-foreground relative overflow-hidden min-h-screen flex flex-col justify-center border-b border-border">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle, currentColor 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} />

      <div className="container mx-auto px-6 md:px-12 lg:px-20 relative z-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="mb-8">
              <span className="font-mono text-[0.75rem] md:text-[0.875rem] font-medium uppercase tracking-[0.2em] text-primary flex items-center gap-3">
                <span className="w-8 h-px bg-primary" />
                DIGITAL FOUNDRY [v2.0]
              </span>
            </div>

            <h1 className="font-default font-extrabold text-foreground mb-8 max-w-3xl" style={{
            fontSize: "clamp(2.5rem, 8vw, 5rem)",
            letterSpacing: "-0.04em",
            lineHeight: "0.9"
          }}>
              PRECISION <br />
              ENGINEERING <br />
              <span className="text-primary">REDEFINED.</span>
            </h1>

            <p className="text-foreground/70 max-w-xl mb-12 text-lg md:text-xl leading-relaxed">
              Experience the pinnacle of mobile technology. Our curated selection of flagship smartphones combines cutting-edge performance with sleek, industrial design.
            </p>

            <div className="flex flex-wrap items-center gap-6">
              <Button asChild className="rounded-md bg-primary text-primary-foreground hover:bg-foreground px-10 py-7 h-auto font-mono uppercase text-sm tracking-wider transition-all duration-300 shadow-lg">
                <Link to="/ShopPage">
                  EXPLORE COLLECTION
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="rounded-md border-foreground/20 hover:border-primary hover:text-primary px-10 py-7 h-auto font-mono uppercase text-sm tracking-wider transition-all duration-300">
                <Link to="/TradeInRepairsPage">TRADE-IN OFFERS</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-1 lg:order-2 relative">
            <div className="relative p-4">
              {}
              <div className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-primary z-20" />
              <div className="absolute top-0 right-0 w-10 h-10 border-t-2 border-r-2 border-primary z-20" />
              <div className="absolute bottom-0 left-0 w-10 h-10 border-b-2 border-l-2 border-primary z-20" />
              <div className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-primary z-20" />
              
              <div className="overflow-hidden bg-muted rounded-md shadow-2xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/flagship_smartphone_ultra_display.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/flagship_smartphone_ultra_display.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/flagship_smartphone_ultra_display.png-wvc-sizes" alt="Flagship Smartphone" loading="lazy" decoding="async" className="w-full h-auto object-cover transition-transform duration-700 hover:scale-105" />
              </div>

              {}
              <div className="absolute -bottom-6 -right-4 bg-foreground text-background px-4 py-2 font-mono text-[0.65rem] tracking-widest uppercase z-30 shadow-xl">
                MODEL: TW-ULTRA-2024
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 bg-foreground/5 border-t border-border py-4 overflow-hidden whitespace-nowrap">
        <div className="flex animate-marquee">
          {[...Array(4)].map((_, i) => <div key={i} className="flex items-center" data-index={i}>
              {tickerItems.map((item, idx) => <span key={item.id} className="mx-8 font-mono text-[0.7rem] text-foreground/40 flex items-center gap-2">
                  <span className="size-1.5 bg-primary rounded-md" />
                  {item.text}
                </span>)}
            </div>)}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
          display: flex;
          width: max-content;
        }
      `
    }} />
    </section>;
}